module.exports = __webpack_public_path__ + "static/media/loginBg.c1b07be5.svg";